const teamState = {
  data: {
    teamId: "",
    isOwner: false,
    teams: [],
    teamMembers: [],
    invitations: [],
    activeSection: "team",
    accessibleSection: [],
    isAccessibleSectionLoaded: false,
  },
};

export default teamState;
